export default __webpack_public_path__ + "static/media/logo.a6a829c2.webp";